import { useId, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import BackButton from './BackButton.js';
import './index.css';

function Login() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const emailId = useId();
  const [searchParams] = useSearchParams();
  const linkError = searchParams.get('error');

  async function requestLink(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await fetch('/auth/request-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) throw new Error(data?.msg || 'Failed to send login link.');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className='page'>
      <div className='page-content'>
        <BackButton fallback='/' />
        <div className='card'>
          <h1>Log in</h1>
          <p>Enter the email you upload with — we'll send you a link to log in, no password needed.</p>

          {linkError === 'expired' && (
            <p role='alert' className='help-text'>That login link expired or was already used. Request a new one below.</p>
          )}
          {linkError === 'invalid' && (
            <p role='alert' className='help-text'>That login link isn't valid. Request a new one below.</p>
          )}

          {sent ? (
            <p role='status'>Check your email for a login link. It expires in 15 minutes.</p>
          ) : (
            <form onSubmit={requestLink}>
              <div className='field'>
                <label className='label' htmlFor={emailId}>Email</label>
                <input
                  id={emailId}
                  className='input'
                  type='email'
                  autoComplete='email'
                  inputMode='email'
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              {error && <p role='alert' className='help-text'>{error}</p>}
              <button type='submit' className='btn btn-primary' disabled={submitting}>
                {submitting ? 'Sending…' : 'Send login link'}
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}

export default Login;
